import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

/**
 * @author Burak Ak
 */

export const SalesBySKUConfig = {
	id: DYNAMICLISTS.SALES_BY_SKU_REPORT,
	columns: [
		{ Header: 'ID', accessor: 'ID', filterType: FilterType.number, width: 50, show: false },
		{ Header: 'name', accessor: 'name', filterType: FilterType.string, width: 70, showOnMobile: true },
		{ Header: 'sku', accessor: 'SKU', filterType: FilterType.string, width: 70 },
		{
			Header: 'pickupLocation',
			accessor: 'pickupLocation',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.PICKUP_LOCATION,
			width: 80
		},
		{
			Header: 'category',
			accessor: 'category',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.PRODUCT_CATEGORIES,
			width: 90,
			show: false
		},
		{
			Header: 'quantity',
			accessor: 'quantity',
			filterType: FilterType.number,
			width: 100
		},
		{
			Header: 'total',
			accessor: 'total',
			filterType: FilterType.float,
			width: 120,

			renderCell: ListComponents.CURRENCY
		},
		{
			Header: 'quantityPercentage',
			accessor: 'quantityPercentage',
			filterType: FilterType.float,
			width: 100
		}
	],
	fetchUrl: REPORT.LIST.GET_SALES_BY_SKU_LIST,
	exportName: 'salesBySKU'
};

const SalesBySKU = () => {
	const { state } = useLocation();

	const defaultFilters = useMemo(() => {
		if (!state?.data || Object.keys(state?.data)?.length === 0) {
			return [];
		}

		return [
			{
				column: {
					Header: 'orderDate',
					accessor: 'createdAt',
					filterType: FilterType.date,
					filterRemovable: false,
					customFilterOptions: [FilterAction.between, FilterAction.on]
				},
				action: FilterAction.between,
				value: state.data.date
			}
		];
	}, []);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="salesBySKU"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.ORDER_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList {...SalesBySKUConfig} defaultFilters={defaultFilters} />
		</div>
	);
};

export default SalesBySKU;
